import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const schemeApi = createApi({
  reducerPath: 'schemeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Scheme'],
  endpoints: (builder) => ({
    getSchemes: builder.query({
      query: ({ page, limit, search, is_active, status, client_id } = {}) => ({
        url: 'schemes',
        params: buildQueryParams({ page, limit, search, is_active, status, client_id }),
      }),
      providesTags: ['Scheme'],
    }),
    getSchemeById: builder.query({
      query: (id) => `schemes/${id}`,
      providesTags: ['Scheme'],
    }),
    createScheme: builder.mutation({
      query: (formData) => ({
        url: 'schemes',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Scheme'],
    }),
    updateScheme: builder.mutation({
      query: ({ id, body }) => ({
        url: `schemes/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Scheme'],
    }),
    deleteScheme: builder.mutation({
      query: (id) => ({
        url: `schemes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Scheme'],
    }),
  }),
});

export const {
  useGetSchemesQuery,
  useGetSchemeByIdQuery,
  useCreateSchemeMutation,
  useUpdateSchemeMutation,
  useDeleteSchemeMutation,
} = schemeApi;
